import axios from "axios";

const API_URL = "https://script.google.com/macros/s/AKfycbyCBeZYgJ1L_iCfo8qtzbqt4k43d7GOUj4EIjIB9UvZdMC0c9adWyYpuSRoY_4c1nI_1Q/exec";

export const getData = async (sheet, project = null) => {
    const response = await axios.get(API_URL, { params: { sheet, project } });
    return response.data;
};